import { useSelector } from 'react-redux';

// project constants
import { appConfigMeta, type RootState } from '@a1/shared';

const defaultAppConfig = appConfigMeta as RootState['appConfig']['data'];
/**
 * Gets the name of an entity.
 * @param id Entity id (key)
 * @param config App config
 * @returns Entity name (value) or id
 */
const getEntityName = (id: string, config?: RootState['appConfig']['data']): string =>
  config?.entities?.[id] || defaultAppConfig?.entities?.[id] || id;

/**
 * Hook that returns the name of an entity without requiring appConfig as a parameter
 * @param id Entity id (key)
 * @returns Entity name (value) or id
 */
const useGetEntityName = (id: string): string => {
  const appConfig = useSelector((state: RootState) => state.appConfig?.data);
  return getEntityName(id, appConfig);
};

export { getEntityName, useGetEntityName };
